// SummaryTable.js
import React, { useState } from "react";
import "./summaryTable.css"; // スタイルを適用するCSSファイルを追加

const SummaryTable = ({ summaryData }) => {
  // 合計値を算出
  const totalCount = Object.values(summaryData).reduce((sum, data) => sum + data.count, 0);
  const totalCapacityA = Object.values(summaryData).reduce((sum, data) => sum + data.totalCapacityA, 0);
  const totalCapacityKVA = Object.values(summaryData).reduce((sum, data) => sum + data.totalCapacityKVA, 0);

  // タイプのソート関数
  const sortType = (type) => {
    const match = type.match(/(単相|三相)(\d+)/);
    if (match) {
      const [_, phase, number] = match;
      return [(phase === "単相" ? 0 : 1), parseInt(number, 10)];
    }
    return [2, type]; // その他のタイプは最後に
  };

  return (
    <div className="summary-container">
        <table className="summary-table">
            <thead>
              <tr>
                <th>タイプ</th>
                <th>数量</th>
                <th>合計容量[A]</th>
                <th>合計容量[KVA]</th>
              </tr>
            </thead>
            <tbody>
              {Object.entries(summaryData)
                .sort(([typeA], [typeB]) => {
                  const [groupA, numA] = sortType(typeA);
                  const [groupB, numB] = sortType(typeB);
                  return groupA - groupB || numA - numB;
                })
                .map(([type, data]) => (
                <tr key={type}>
                  <td>{type}</td>
                  <td>{data.count}</td>
                  <td>{data.totalCapacityA}</td>
                  <td>{data.totalCapacityKVA}</td>
                </tr>
              ))}
              {/* 合計行を追加 */}
              <tr className="summary-total-row">
                <td><strong>合計</strong></td>
                <td><strong>{totalCount}</strong></td>
                <td><strong>{totalCapacityA}</strong></td>
                <td><strong>{totalCapacityKVA}</strong></td>
              </tr>
            </tbody>
        </table>
    </div>
  );
};

export default SummaryTable;